/* global fetch */

import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import { PhotoStory } from "../story-templates/photo-story";
import { LiveBlogStory } from "../story-templates/live-blog";
import { VisualStory } from "../story-templates/visual-story";
import { VideoStory } from "../story-templates/video-story";
import { TextStory } from "../story-templates/text-story/";
import { ListicleStory } from "../story-templates/listicle-story";
import { OtherStory } from "../story-templates/other";
import { Snapshot } from "../story-templates/snapshot";
import { InfiniteStoryBase } from "@quintype/components";
import { getInfiniteScrollApi } from "../../utils";

export function StoryPageContent(data, config) {
  const { story, preview = false, index } = data;
  const firstStory = index === 0;
  const infiniteScrollStyle = get(config, ["theme-attributes", "infiniteScrollStyle"], "default");
  const showStoryTemplate = infiniteScrollStyle !== "read-more" || (infiniteScrollStyle === "read-more" && firstStory);
  if (!showStoryTemplate) return <Snapshot story={story} config={config} firstStory={firstStory} />;
  switch (story["story-template"]) {
    case "live-blog":
      return <LiveBlogStory story={story} config={config} preview={preview} firstStory={firstStory} />;
    case "video":
      return <VideoStory story={story} config={config} preview={preview} firstStory={firstStory} />;
    case "photo":
      return <PhotoStory story={story} config={config} preview={preview} firstStory={firstStory} />;
    case "visual-story":
      return <VisualStory story={story} config={config} firstStory={firstStory} />;
    case "listicle":
      return <ListicleStory story={story} config={config} preview={preview} firstStory={firstStory} />;
    case "news-elsewhere":
      return null;
    case "other":
      return <OtherStory story={story} config={config} preview={preview} firstStory={firstStory} />;
    default:
      return <TextStory story={story} config={config} preview={preview} firstStory={firstStory} />;
  }
}

function storyPageLoadItems(pageNumber, story = {}, config = {}) {
  const infiniteScrollType = get(config, ["theme-attributes", "infinite-scroll"], "");
  const sectionId = get(story, ["sections", 0, "id"], null);
  const params = {
    pageNumber,
    sectionId
  };
  let infiniteScrollApi = getInfiniteScrollApi(infiniteScrollType, params);
  return fetch(infiniteScrollApi)
    .then(response => {
      return response.json();
    })
    .then(response => {
      const items = response.stories || response.items || [];
      return items.map(item => ({ story: item.story || item }));
    })
    .catch(err => {
      console.error("Error in retrieving infinite scroll stories :", err);
      return [];
    });
}

export class StoryPage extends React.Component {
  doAnalytics(story) {
    const { registerPageView } = require("@quintype/framework/client/analytics");
    registerPageView({ type: "story-page", story: story }, `/${story.slug}`);
  }

  render() {
    const infiniteScrollType = get(this.props.config, ["theme-attributes", "infinite-scroll"], "");
    const firstStory = this.index === 0;
    const infiniteScrollStyle = get(this.props.config, ["theme-attributes", "infiniteScrollStyle"], "default");
    const showStoryTemplate =
      infiniteScrollStyle !== "read-more" || (infiniteScrollStyle === "read-more" && firstStory);

    if (this.props.preview || infiniteScrollType === "disabled") {
      return StoryPageContent(this.props.data, this.props.config);
    }

    return (
      <div className="infinite-wrapper">
        {!showStoryTemplate ? (
          <InfiniteStoryBase
            {...this.props}
            render={storyProps => StoryPageContent(storyProps, this.props.config)}
            loadItems={storyPageLoadItems}
            onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
            onInitialItemFocus={item => this.doAnalytics(item.story)}
            doNotChangeUrl={true}
          />
        ) : (
          <InfiniteStoryBase
            {...this.props}
            render={storyProps => StoryPageContent(storyProps, this.props.config)}
            loadItems={storyPageLoadItems}
            onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
            onInitialItemFocus={item => this.doAnalytics(item.story)}
          />
        )}
      </div>
    );
  }
}

StoryPageContent.propTypes = {
  config: PropTypes.object,
  data: PropTypes.shape({
    story: PropTypes.object,
    relatedStories: PropTypes.array,
    index: PropTypes.number,
    preview: PropTypes.bool
  })
};

StoryPage.propTypes = {
  preview: PropTypes.bool,
  config: PropTypes.object,
  data: PropTypes.shape({
    story: PropTypes.object,
    relatedStories: PropTypes.array,
    index: PropTypes.number,
    preview: PropTypes.bool
  })
};
